var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 5,
    viewBox: "0 0 17 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 4.0625C13.8871 4.0625 13.1875 3.36294 13.1875 2.5C13.1875 1.63705 13.8871 0.9375 14.75 0.937499C15.6129 0.937499 16.3125 1.63705 16.3125 2.5C16.3125 3.36294 15.6129 4.0625 14.75 4.0625Z",
    fill: "#17191F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.0625C7.63705 4.0625 6.9375 3.36295 6.9375 2.5C6.9375 1.63706 7.63705 0.9375 8.5 0.9375C9.36294 0.9375 10.0625 1.63706 10.0625 2.5C10.0625 3.36294 9.36295 4.0625 8.5 4.0625Z",
    fill: "#17191F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 2.5C0.6875 3.36295 1.38705 4.0625 2.25 4.0625C3.11295 4.0625 3.8125 3.36295 3.8125 2.5C3.8125 1.63706 3.11295 0.937501 2.25 0.937501C1.38705 0.937501 0.6875 1.63706 0.6875 2.5Z",
    fill: "#17191F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.d66283335ac517162aa1bcb9893c34dc.svg";
export { ForwardRef as ReactComponent };